import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Paiement } from '../model/paiement';

@Injectable({
    providedIn: 'root'
  })
  export class PaiementService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    getPaiementListByNumEcheance(numEcheance)
    {
        return this._restClientService.load<Paiement[]>('paiement/paiementlist-by-numecheance?numEcheance='+numEcheance);
    }

}      

    